import BaseService from '../../BaseService'

export default class VNBService extends BaseService {

  constructor() {
    super('vnb')
  }
}
